module.exports = __webpack_public_path__ + "static/media/view3.698b6176.jpg";